import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pt-15 break-words md:flex md:justify-center md:items-center md:w-1/2" }
const _hoisted_2 = { class: "w-9/10 px-20 md:px-60 lg:w-5/6" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "my-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaHandler = _resolveComponent("MediaHandler")!
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["flex w-full", _ctx.flexOrderClass])
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle('color:' + _ctx.content.textColor),
      class: "w-full md:w-1/2"
    }, [
      _createVNode(_component_MediaHandler, {
        "media-aspect-ratio": _ctx.aspectRatio,
        "media-block": _ctx.mediaTileContentBlock.media,
        "video-disable-on-mobile": _ctx.content.disableVideoOnMobile
      }, null, 8, ["media-aspect-ratio", "media-block", "video-disable-on-mobile"])
    ], 4),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.textTileContentBlock.subheading)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "o-text-caption uppercase m-0",
              innerHTML: _ctx.textTileContentBlock.subheading
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.textTileContentBlock.title)
          ? (_openBlock(), _createElementBlock("h2", {
              key: 1,
              innerHTML: _ctx.textTileContentBlock.title
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.textTileContentBlock.text)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.textTileContentBlock.text), 1))
          : _createCommentVNode("", true),
        (_ctx.textTileContentBlock.link)
          ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
              key: 3,
              "link-block": _ctx.textTileContentBlock.link,
              "style-as-button": !_ctx.content.alternativeLinkStyle,
              class: "mt-15 md:mt-25 max-w-full"
            }, null, 8, ["link-block", "style-as-button"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}